import { DETAIL_BY_OPTIONS } from '../../constant';
import type { ExcelColumnMapping } from './types';
import { roundNumber } from '@/lib/formatUtils';

const getDetailLabel = (detailBy?: number) => DETAIL_BY_OPTIONS.find(option => option.value === detailBy)?.label ?? '';

export const getBaoCaoBanHangNhomTheoHaiChiTieuColumns = (detailBy?: number): ExcelColumnMapping[] => {
  const detailLabel = getDetailLabel(detailBy);
  const nameSuffix = detailLabel ? ` ${detailLabel}` : '';

  return [
    { header: `Mã${nameSuffix}`, resolver: row => row.ma ?? '' },
    { header: `Tên${nameSuffix}`, resolver: row => row.ten ?? '' },
    { header: 'Số lượng', resolver: row => roundNumber(Number(row.sl_xuat ?? 0)) },
    { header: 'Giá bán', resolver: row => roundNumber(Number(row.gia2 ?? 0)) },
    { header: 'Doanh số', resolver: row => roundNumber(Number(row.tien2 ?? 0)) },
    { header: 'Thuế', resolver: row => roundNumber(Number(row.thue ?? 0)) },
    { header: 'Chiết khấu', resolver: row => roundNumber(Number(row.ck ?? 0)) },
    { header: 'Trả lại', resolver: row => roundNumber(Number(row.tien_tl ?? 0)) },
    { header: 'Phải thu', resolver: row => roundNumber(Number(row.pt ?? 0)) },
    { header: 'Giá vốn', resolver: row => roundNumber(Number(row.gia ?? 0)) },
    { header: 'Tiền vốn', resolver: row => roundNumber(Number(row.tien_von ?? 0)) },
    { header: 'Lãi', resolver: row => roundNumber(Number(row.lai ?? 0)) },
    { header: '% GV/GB', resolver: row => roundNumber(Number(row.tl_gv_gb ?? 0)) }
  ];
};

export const BAO_CAO_BAN_HANG_NHOM_THEO_HAI_CHI_TIEU_COLUMNS = getBaoCaoBanHangNhomTheoHaiChiTieuColumns();
